import React, { HTMLAttributes, ReactNode } from "react";
import headingImg from "images/heading-guides.webp";

export interface HeadingGuidesProps extends HTMLAttributes<HTMLHeadingElement> {
  desc?: ReactNode;
  isCenter?: boolean;
}

const HeadingGuides: React.FC<HeadingGuidesProps> = ({
  children,
  desc = "Toutes les informations sur vos destinations",
  className = "",
  isCenter = true,
  ...args
}) => {
  return (
    <div
  className={`
    relative
    overflow-hidden
    rounded-b-[2.5rem]
    bg-cover
    bg-center
    bg-no-repeat
    px-4
    pb-12
    pt-14
    md:pb-16
    md:pt-20
    ${className}
  `}
  style={{
    backgroundImage: `url(${headingImg})`,
  }}
>
  
      <div
        className={
          isCenter
            ? "relative z-10 mx-auto max-w-4xl text-center"
            : "relative z-10 max-w-4xl"
        }
      >
        <h2
          className="
            text-4xl
            font-black
            tracking-tight
            text-slate-950
            md:text-6xl
          "
          {...args}
        >
          {children}
        </h2>

        {desc && (
          <span
            className="
              mx-auto
              mt-4
              block
              max-w-2xl
              text-base
              font-medium
              text-slate-500
              md:text-xl
            "
          >
            {desc}
          </span>
        )}
      </div>
    </div>
  );
};

export default HeadingGuides;